import "../chunk-D57E6H3M.mjs";

// src/utils/formatTimestamp.ts
import { componentsI18n, normalizeLocale } from "../i18n/instance.mjs";
var DAY_MS = 24 * 60 * 60 * 1e3;
function calendarDay(date) {
  return Date.UTC(date.getFullYear(), date.getMonth(), date.getDate());
}
function capitalise(text, locale) {
  return text.charAt(0).toLocaleUpperCase(locale) + text.slice(1);
}
function formatTimestamp(value, { now, locale = "en", time = false, inline = false }) {
  if (value === null || value === void 0 || value === "") return null;
  const date = new Date(value);
  if (!Number.isFinite(date.getTime())) return null;
  const today = new Date(now);
  const days = Math.max(0, Math.round((calendarDay(today) - calendarDay(date)) / DAY_MS));
  const clock = new Intl.DateTimeFormat(locale, { hour: "numeric", minute: "2-digit" }).format(date);
  const relative = new Intl.RelativeTimeFormat(locale, { numeric: "auto" });
  let day;
  if (days === 0) {
    day = relative.format(0, "day");
  } else if (days === 1) {
    day = relative.format(-1, "day");
  } else if (days > 1 && days < 7) {
    day = new Intl.DateTimeFormat(locale, { weekday: "long" }).format(date);
  } else {
    const year = date.getFullYear() === today.getFullYear() ? void 0 : "numeric";
    day = new Intl.DateTimeFormat(locale, { month: "short", day: "numeric", year }).format(date);
  }
  let text;
  if (time && days === 0) text = clock;
  else if (time) text = componentsI18n.t("timestamp.dayAtTime", { lng: normalizeLocale(locale), day, time: clock });
  else text = day;
  return {
    text: inline ? text : capitalise(text, locale),
    dateTime: date.toISOString(),
    title: new Intl.DateTimeFormat(locale, { dateStyle: "full", timeStyle: "short" }).format(date)
  };
}
export {
  formatTimestamp
};
//# sourceMappingURL=formatTimestamp.mjs.map